'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('@arreeba/ristoranti-lib/lib/util');

var _appType = require('@arreeba/ristoranti-lib/lib/constants/appType');

exports.default = function (bundleId) {
  var deviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'IOS';
  return {
    loadConfiguration: function loadConfiguration(api, appAction) {
      var query = 'query {\n      app(bundleId: "' + bundleId + '" deviceType: ' + (0, _util.serializeEnum)(deviceType) + ') {\n        id\n        config\n        active\n        environment\n        merchant {\n          id\n          name\n          social {\n            facebook {\n              pageUrl\n              appId\n            }\n            twitter {\n              username\n            }\n            instagram {\n              username\n            }\n          }\n          restaurants {\n            id\n            name\n            services {\n              id\n              online\n              active\n              offset\n            }\n            location {\n              latitude\n              longitude\n            }\n            address\n            fullAddress {\n              route\n              street_number\n              postal_code\n              city\n              country\n            }\n            email\n            phone\n            zipCode\n            city\n            country\n            cuisine\n            highlights {\n              name\n              check\n            }\n            openingTimes {\n              day\n              open\n              slots {\n                open\n                close\n              }\n            }\n            takeAwayTimes {\n              day\n              open\n              slots {\n                open\n                close\n              }\n            }\n            deliveryTimes {\n              day\n              open\n              slots {\n                open\n                close\n              }\n            }\n          }\n        }\n      }\n    }';

      var queryName = 'loadConfiguration';
      return (0, _util.wrapAction)(appAction, 'app[0]', 'loadConfiguration', api.fetch(query, {}, queryName));
    },
    registerDevice: function registerDevice(api, data) {
      // doesn't need appAction, it makes the call behind the scenes
      var query = '\n      mutation {\n        registerDevice(\n          id: "' + data.id + '"\n          appType: ' + (data.appType || _appType.STANDALONE) + '\n          type: ' + (0, _util.serializeEnum)(deviceType) + '\n          bundleId: "' + bundleId + '"\n          osVersion: "' + data.osVersion + '"\n          appVersion: "' + data.appVersion + '"\n          bundleVersion: "' + data.bundleVersion + '"\n        ) {\n          id\n        }\n      }\n    ';

      var queryName = 'registerDevice';
      return api.fetch(query, {}, queryName);
    },
    updateDeviceToken: function updateDeviceToken(api, data) {
      var query = '\n      mutation {\n        registerDeviceToken(\n          deviceUUID: "' + data.deviceUUID + '"\n          deviceToken: "' + data.deviceToken + '"\n          bundleId: "' + bundleId + '"\n          type: ' + (0, _util.serializeEnum)(deviceType) + '\n        ) {\n          id\n        }\n      }\n    ';

      var queryName = 'registerDeviceToken';
      return api.fetch(query, {}, queryName);
    },
    unregisterDeviceToken: function unregisterDeviceToken(api, data) {

      // If only data.user is set, every device token associated to that user will be deleted.
      // If only data.deviceToken is set, only that device token will be deleted.
      // If both data.user and data.deviceToken are set, only that device token will be deleted (if associated to that user).

      var query = '\n      mutation {\n        unregisterDeviceToken(\n          bundleId: "' + bundleId + '"\n          type: ' + (0, _util.serializeEnum)(deviceType) + '\n          ' + (data.user ? 'user: "' + data.user + '"' : '') + '\n          ' + (data.deviceToken ? 'deviceToken: "' + data.deviceToken + '"' : '') + '\n        )\n      }\n    ';

      var queryName = 'unregisterDeviceToken';
      return api.fetch(query, {}, queryName);
    },


    // TODO move to @arreeba/ristoranti-lib
    askResetPasswordEmail: function askResetPasswordEmail(api, data) {
      var query = '\n      mutation {\n        resetPassword(\n          app:"' + data.app + '"\n          email: "' + data.email + '"\n        )\n      }';

      var queryName = 'resetPassword';
      return api.fetch(query, {}, queryName);
    },
    verifyRecoveryToken: function verifyRecoveryToken(api, data, appAction) {
      var query = '\n      mutation {\n        verifyRecoveryToken(\n          token: "' + data.token + '"\n          app: "' + data.app + '"\n          device: "' + data.device + '"\n        )\n      }';

      var queryName = 'verifyRecoveryToken';
      return (0, _util.wrapAction)(appAction, queryName, 'verifyRecoveryToken', api.fetch(query, {}, queryName));
    },
    resetPassword: function resetPassword(api, data, appAction) {
      var query = '\n      mutation {\n        updatePassword(\n          newPassword: "' + data.password + '"\n          confirmPassword: "' + data.passwordConfirm + '"\n        )\n      }\n    ';

      var queryName = 'resetPassword';
      return (0, _util.wrapAction)(appAction, queryName, 'resetPassword', api.fetch(query, {}, queryName));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/services/app.js
// module id = 199
// module chunks = 0